import styled from "styled-components";
import { RawButton } from "../../../../Styled/Button";
import Button from "../../../../Styled/Button";
import { scrollBars } from "../../../../Styled/mixins";
export const GridItem = styled.span.withConfig({
  displayName: "DateTimePickerStyles__GridItem",
  componentId: "sc-d7i4uz-0"
})(["background:", ";", ""], p => p.theme.overlay, p => p.active && "\n    & {\n      background: ".concat(p.theme.colorPrimary, ";\n    }\n    opacity: 0.9;\n   "));
export const GridRowInner = styled.span.withConfig({
  displayName: "DateTimePickerStyles__GridRowInner",
  componentId: "sc-d7i4uz-1"
})(["display:table-row;padding:3px;border-radius:3px;span{display:inline-block;height:10px;width:2px;margin-top:1px;margin-right:", "px;}"], p => p.marginRight);
export const Grid = styled.div.withConfig({
  displayName: "DateTimePickerStyles__Grid",
  componentId: "sc-d7i4uz-2"
})(["display:block;width:100%;height:100%;margin:0 auto;color:", ";padding:0px 5px;border-radius:3px;margin-top:-20px;"], p => p.theme.textLight);
export const GridHeading = styled.div.withConfig({
  displayName: "DateTimePickerStyles__GridHeading",
  componentId: "sc-d7i4uz-3"
})(["text-align:center;color:", ";font-size:12px;margin-bottom:10px;"], p => p.theme.textLight);
export const GridRow = styled.div.withConfig({
  displayName: "DateTimePickerStyles__GridRow",
  componentId: "sc-d7i4uz-4"
})([":hover{background:", ";cursor:pointer;}"], p => p.theme.overlay);
export const GridLabel = styled.span.withConfig({
  displayName: "DateTimePickerStyles__GridLabel",
  componentId: "sc-d7i4uz-5"
})(["float:left;display:inline-block;width:35px;font-size:10px;padding-left:3px;"]);
export const GridBody = styled.div.withConfig({
  displayName: "DateTimePickerStyles__GridBody",
  componentId: "sc-d7i4uz-6"
})(["height:calc(100% - 30px);overflow:auto;", ""], p => scrollBars(p));
export const BackButton = styled(RawButton).withConfig({
  displayName: "DateTimePickerStyles__BackButton",
  componentId: "sc-d7i4uz-7"
})(["display:inline-block;z-index:99;position:relative;svg{height:15px;width:20px;fill:", ";display:inline-block;vertical-align:bottom;}&[disabled],&:disabled{opacity:0.1;}"], p => p.theme.textLight);
export const DateButton = styled(Button).attrs({
  primary: true,
  textProps: {
    medium: true
  }
}).withConfig({
  displayName: "DateTimePickerStyles__DateButton",
  componentId: "sc-d7i4uz-8"
})(["width:calc(100% - 20px);margin:3px 5px;border-radius:4px;"]);